import angular from 'angular';
import ExtractionConst from '../constants/extraction';
import DateParserServ from './date-parser/date-parser'

class ExtractionServ {
  constructor(ExtractionConst, DateParserServ) {
    this.dateParserServ = DateParserServ
    this.matchers = ExtractionConst.matchers
    this.tests = ExtractionConst.tests

  }
  extract(value) {
    let extracted = {}
    const factDateish = this.parseDate(value)
    const title = this.parseTitle(value)
    if (title) {
      extracted.title = title
    }
    if (factDateish) {
      extracted.factDateish = factDateish
    }
    return extracted
    
  }
  parseDate(value) {

    // step through recognized date formats, and compare fact content
    // against RegExp constructed from `tests`. If a match is found,
    // call appropriate date property setters defined in `postions`.
    var date
    var test
    var match
    for (var i = this.tests.length - 1; i >= 0; i--) {
      test = new RegExp(this.tests[i].map(
        k => this.matchers[k] ? this.matchers[k] : k
      ).join(''), 'i')

      match = test.exec(value)
      if (match) {
        date = this.dateParserServ.parse(match[0])
        if (this.dateParserServ.validate(date)) {
          return date
        }
      }
    }
  }
  parseTitle(value) {
    var words;
    var ignore = ['a', 'and', 'at', 'by', 'for', 'in', 'into', 'is',
      'it', 'of', 'on', 'such', 'that', 'the', 'their', 'then',
      'there', 'these', 'they', 'this', 'to', 'was', 'will'
    ];
    var keyWordCount = 0;
    var titleWords = [];

    // get the first 250 chars,
    // filter out html entities, links, and punctuation (except quotes, question, dashes)
    // and split string into an array by spaces, tabs, returns
    words = value.substr(0, 250).
    replace(
      /&[^\s]+?;|(http(s?)|www).+?(?=\s)|[^\s\w\?"'‘’“”''""‹›«»\-‒–—―]/g,
      '').
    split(/\s/g).filter(function (el) {
      return el.length !== 0;
    });

    // return a title with at least 4 key words once text is longer
    for (var i = 0; i < words.length; i++) {
      titleWords.push(words[i]);
      if (ignore.indexOf(words[i]) === -1) {
        keyWordCount++;
      }
      if (keyWordCount >= 4 && (titleWords[titleWords.length - 1] !==
          words[words.length - 1])) {
        return titleWords.join(' ');
      }
    }

  }

}
ExtractionServ.$inject = ['ExtractionConst', 'DateParserServ'];

export default angular.module('services.extraction', [ExtractionConst, DateParserServ])
  .service('ExtractionServ', ExtractionServ)
  .name;



// WEBPACK FOOTER //
// ./project/services/extraction.js